import { createAction, props } from '@ngrx/store'
import { Family } from './family.state'

// Action to load Department
export const loadFamilies = createAction(
  '[Family] Load Family',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful Family load
export const loadFamiliesSuccess = createAction(
  '[Family] Load Family Success',
  props<{
    families: Family[]
  }>()
)

// Action for Department load failure
export const loadFamiliesFailure = createAction(
  '[Family] Load Family Failure',
  props<{ error: string }>()
)

export const createFamily = createAction(
  '[Family] Create Family',
  props<{
    payload: any
  }>()
)

export const createFamilySuccess = createAction(
  '[Family] Create Family Success',
  props<{ family: Family }>()
)

export const createFamilyFailure = createAction(
  '[Family] Create Family Failure',
  props<{ error: any }>()
)

export const updateFamily = createAction(
  '[Family] Update Family',
  props<{ id: string; payload: any }>()
)

export const updateFamilySuccess = createAction(
  '[Family] Update Family Success',
  props<{ family: Family }>()
)

export const updateFamilyFailure = createAction(
  '[Family] Update Family Failure',
  props<{ error: any }>()
)

export const deleteFamily = createAction('[Family] Delete Family', props<{ id: string }>())

export const deleteFamilySuccess = createAction(
  '[Family] Delete Family Success',
  props<{ id: string }>()
)

export const deleteFamilyFailure = createAction(
  '[Family] Delete Family Failure',
  props<{ error: any }>()
)
